module.exports = __webpack_public_path__ + "img/coin.cbf7a051.png";